(function () {
  'use strict';

  function initStickyAtc(bar) {
    var trigger = bar.dataset.trigger || 'form';
    var mainForm = document.querySelector('.pi-info product-form') || document.querySelector('product-info product-form');
    var watchTarget = trigger === 'gallery' ? document.querySelector('.pdp-main-grid-gallery') : mainForm;

    if (watchTarget && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe(watchTarget);
    }

    var qtyInput = bar.querySelector('[data-satc-qty-input]');
    var decBtn = bar.querySelector('[data-satc-qty-decrease]');
    var incBtn = bar.querySelector('[data-satc-qty-increase]');

    if (decBtn && qtyInput) {
      decBtn.addEventListener('click', function () {
        var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = val;
      });
    }
    if (incBtn && qtyInput) {
      incBtn.addEventListener('click', function () {
        var val = (parseInt(qtyInput.value, 10) || 1) + 1;
        qtyInput.value = val;
      });
    }

    var cta = bar.querySelector('[data-satc-add-to-cart]');
    if (cta) {
      cta.addEventListener('click', function () {
        if (!mainForm) return;
        var infoEl = mainForm.closest('product-info');
        var mainQtyInput = infoEl ? infoEl.querySelector('.quantity__input') : null;
        if (mainQtyInput && qtyInput) mainQtyInput.value = qtyInput.value;
        var submitBtn = mainForm.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.click();
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-sticky-atc]').forEach(initStickyAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
